<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
      <el-breadcrumb-item>游戏角色</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="page-content">
    <el-row @keyup.enter.native="loadData(1)">
<!--      <el-input v-model="queryField.gameId" size="small" placeholder="游戏ID"></el-input>-->
<!--      <el-input v-model="queryField.gameName" size="small" placeholder="游戏名称"></el-input>-->
      <el-select
          size="small"
          ref="selectGame"
          v-model="game"
          filterable
          remote
          reserve-keyword
          placeholder="游戏名称"
          @change="handleSelect2"
          :remote-method="loadGame"
          @visible-change="cancelReadOnly"
      >
        <el-option
            v-for="item in restaurants2"
            :key="item.key"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="queryField.userId" size="small" placeholder="玩家id"></el-input>
      <el-input v-model="queryField.userName" size="small" placeholder="玩家账号"></el-input>
      <el-input v-model="queryField.serverCode" size="small" placeholder="区服"></el-input>
      <el-input v-model="queryField.serverName" size="small" placeholder="区服名称"></el-input>
      <el-input v-model="queryField.roleCode" size="small" placeholder="角色编号"></el-input>
      <el-input v-model="queryField.roleName" size="small" placeholder="角色名称"></el-input>
      <el-autocomplete
          class="inline-input"
          v-model="firstChannel"
          :fetch-suggestions="querySearch"
          value-key="nickName"
          placeholder="归属渠道"
          @select="handleSelect"
      ></el-autocomplete>
      <br>
      <br>
      <el-date-picker
          size="small"
          v-model="queryField.startTime"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="开始日期">
      </el-date-picker>
      <el-date-picker
          size="small"
          v-model="queryField.endTime"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="结束日期">
      </el-date-picker>
      <el-button v-if="showQuery"  type="primary" icon="el-icon-search" size="small" :loading="loadingQuery" @click="loadData(1)">查询</el-button>
      <el-button
          type="primary"
          @click="moveSission"
          size="small"
      >重置</el-button
      >
    </el-row>
    <el-table class="cps-table-data"
              :data="tableData" size="small"
              border
              :height="height"
              style="width: 100%">
      <el-table-column
          prop="game_id"
          label="游戏ID"
          width="80">
      </el-table-column>
      <el-table-column
          prop="game_name"
          label="游戏名称"
          width="200">
      </el-table-column>
      <el-table-column
          prop="user_id"
          label="账号id"
          width="80">
      </el-table-column>
      <el-table-column
          prop="user_name"
          label="玩家账号"
          width="120">
      </el-table-column>
      <el-table-column
          prop="admin_name"
          label="归属渠道"
          width="120">
      </el-table-column>
      <el-table-column
          prop="server_code"
          label="区服"
          width="120">
      </el-table-column>
      <el-table-column
          prop="server_name"
          label="区服名称"
          width="120">
      </el-table-column>
      <el-table-column
          prop="role_code"
          label="角色id"
          width="240">
      </el-table-column>
      <el-table-column
          prop="role_name"
          label="角色名字"
          width="180">
      </el-table-column>
      <el-table-column
          prop="role_level"
          label="角色等级"
          width="80">
      </el-table-column>
      <el-table-column
          prop="add_time"
          label="角色创建时间"
          width="140">
      </el-table-column>
    </el-table>
    <el-pagination  class="cps-table-data"
        @current-change="loadData"
        background
        :page-size="15"
        layout="total, prev, pager, next"
        :total="total">
    </el-pagination>
    </div>
  </div>
</template>
<script>
import {queryGameRoleList, getPageButtons, channelDropDown, loadGame} from "@/api/request";
export default {
  name: 'gameRole',
  data() {
    return {
      tableData: [],
      queryField: {
        roleCode:'',
        roleName:'',
        serverCode:'',
        serverName:'',
        gameId: '',
        gameName: '',
        userId: '',
        userName: '',
        adminId: '',
        startTime: '',
        endTime: '',
      },
      restaurants:[],
      restaurants2:[],
      firstChannel: '',
      total: 0,
      height: window.innerHeight - 210,
      showQuery: false,
      loadingQuery: false,
      game: "",
    };
  },
  mounted() {
    this.upgameRole();
    //this.loadData(1);
    this.loadAll();
    this.getPageButtons();
  },
  methods: {
    upgameRole() {
      if (sessionStorage.getItem("gameroleStor") != null) {
        let params = JSON.parse(sessionStorage.getItem('gameroleStor'));
        console.log(params);
        this.queryField.gameId=params.game_id,
        this.queryField.gameName=params.game_name,
        this.queryField.serverCode=params.server_code,
            this.queryField.serverName=params.server_name,
            this.queryField.roleCode=params.role_code,
            this.queryField.roleName=params.role_name,
            this.queryField.userId=params.user_id,
            this.queryField.userName=params.user_name
      }
    },
    moveSission(){
      sessionStorage.removeItem("gameroleStor");
      this.$router.go(0)
    },
    getPageButtons() {
      let path = this.$route.path.replace("/", "");
      getPageButtons(path).then(res => {
        if (res.data.success) {
          let menuCodes = res.data.data;
          //let menuCodes = [];
          this.showQuery = menuCodes.includes("game_role_query");
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    loadData(index) {
      this.loadingQuery = true;
      if (this.queryField.startTime) {
        this.queryField.startTime += " 00:00:00";
      } else {
        this.queryField.startTime = "";
      }

      if (this.queryField.endTime) {
        this.queryField.endTime += " 23:59:59";
      } else {
        this.queryField.endTime = "";
      }
      let params = {
        pageNo: index,
        pageSize: 15,
        params: {
          game_id: this.queryField.gameId,
          game_name: this.queryField.gameName,
          server_code: this.queryField.serverCode,
          server_name: this.queryField.serverName,
          role_code: this.queryField.roleCode,
          role_name: this.queryField.roleName,
          user_id: this.queryField.userId,
          user_name: this.queryField.userName,
          admin_id: this.queryField.adminId,
          start_time: this.queryField.startTime, 
          end_time: this.queryField.endTime, 
        }
      }
      sessionStorage.setItem('gameroleStor', JSON.stringify(params.params))
      queryGameRoleList(params).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }).finally(() => {
        this.loadingQuery = false;
      })
    },
    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.nickName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.queryField.adminId = item.value;
    },
    handleSelect2(item){
      this.queryField.gameId = item
    },
    loadGame(query){
      if (query !== '') {
        let me = this;
        loadGame(query).then(res => {
          me.restaurants2 = [];
          res.data.data.forEach(function (e) {
            let item = {}
            item.key = e.game_id
            item.value = e.game_id
            item.label = e.game_name
            me.restaurants2.push(item)
          })
        })
      }
    },
    cancelReadOnly(value){
      this.$nextTick(() => {
        if (!value) {
          const {selectGame} = this.$refs;
          const input = selectGame.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          this.$refs.selectGame.blur();
        }
      });
    },
    loadAll(){
      let me = this
      channelDropDown().then(res => {
        me.restaurants = []
        let item1 = {}
        item1.value = ''
        item1.nickName = '全部'
        me.restaurants.push(item1)
        res.data.data.forEach(function (e) {
          if (!e.nick_name) {
            e.nick_name = e.admin_id
          }
          let item = {}
          item.value = e.admin_id
          item.nickName = e.nick_name
          me.restaurants.push(item)
        })
      })
    }
  }

}
</script>
<style lang="scss" scoped>
  .cps-main-page {
    .cps-table-data {
      td {
        .el-image {
          display: inherit;
        }
      }
    }
  }
</style>

